module.exports = __webpack_public_path__ + "img/pb.476a61f1.jpg";